import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { RegisterComponent } from './register.component';

@Injectable({ providedIn: 'root' })
export class RegisterGuard implements CanDeactivate<RegisterComponent> {
  canDeactivate(component: RegisterComponent): boolean {
    return component.canDeactivate();
  }
}